"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricDistributionBucketSchema = exports.MetricDistributionSchema = void 0;
const zod_1 = require("zod");
exports.MetricDistributionSchema = zod_1.z.object({
    metric_key: zod_1.z.string(),
    metric_max: zod_1.z.number(),
    metric_min: zod_1.z.number(),
    metric_p5: zod_1.z.number(),
    metric_p95: zod_1.z.number(),
    metric_key_normalised: zod_1.z.string(),
    player: zod_1.z.boolean(),
    team: zod_1.z.boolean(),
});
exports.MetricDistributionBucketSchema = zod_1.z.object({
    metric_key: zod_1.z.string(),
    metric_max: zod_1.z.number(),
    metric_min: zod_1.z.number(),
    metric_p5: zod_1.z.number(),
    metric_p25: zod_1.z.number(),
    metric_p50: zod_1.z.number(),
    metric_p75: zod_1.z.number(),
    metric_p95: zod_1.z.number(),
    buckets: zod_1.z.array(zod_1.z.object({
        bucket: zod_1.z.number(),
        distribution_frequency: zod_1.z.number(),
    })),
});
//# sourceMappingURL=metricDistribution.js.map